import { Link } from 'react-router';
import { useDocumentMeta } from '../document-meta.js';
import { useLocale } from '../locale.js';

export function NotFound() {
  const { t } = useLocale();
  useDocumentMeta(t.meta.notFound);
  return (
    <article className="notfound-page">
      <h1 className="page-title">{t.errors.notFound}</h1>
      <p className="page-lead">{t.errors.notFoundBody}</p>
      <Link className="rp-button rp-button--primary" to="/">
        {t.brand.product}
      </Link>
    </article>
  );
}
